import { filter, map, Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { Maybe, ResourcesGQL } from '@iss/libs/graphql';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  Inject,
  inject,
  Input,
  OnInit,
  Self,
} from '@angular/core';

import { Resource, Resources } from './resource-type-input.types';

import { TypeaheadSelectComponent } from '@iss/core/typeahead-select';
import { Control, NOOP_VALUE_ACCESSOR } from '@iss/core/forms';

@Component({
  selector: 'wo-resource-input',
  templateUrl: './resource-input.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    TypeaheadSelectComponent,
  ],
})
export class ResourceInputComponent implements OnInit {
  private readonly query = inject(ResourcesGQL);

  public loading$!: Observable<boolean>;
  public items$!: Observable<Resources>;

  public readonly stringify = (resources: Resources | null): (code: Resource['code']) => string =>
    code => resources?.find(item => item.code === code)?.presentedName || '';

  public readonly matcher = (resource: Resource): string => resource.presentedName;

  public readonly content = (code: Resource['code'], resources: Resources | null): string | undefined =>
    resources?.find(item => item.code === code)?.presentedName;

  public readonly identity = (resource: Resource): Resource['code'] => resource.code;

  @Input() public readonly: Maybe<boolean>;
  @Input() public loading: Maybe<boolean>;
  @Input() public textFieldCleaner: Maybe<boolean>;
  @Input() public placeholder: Maybe<string>;
  @Input() public multi: Maybe<boolean>;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }

  public ngOnInit(): void {
    this.initQuery();
  }

  private initQuery(): void {
    const query$ = this.query.watch({
      input: {
        offset: 0,
        limit: 999,
        includeInactive: false,
      },
    }).valueChanges;

    this.loading$ = query$.pipe(map(({ loading }) => loading));
    this.items$ = query$.pipe(
      filter(({ data }) => Boolean(data)),
      map(({ data }) => data.resources.resources),
    );
  }
}
